import { LOGIN_API } from '../api'
import axios from 'axios'

export const silentLoginService = async (phoneNumber, accessToken) => {
    const ult = 'otp'
    const ut = 'customer'
    const payload = { ult, ut, phoneNumberRaw: phoneNumber, accessToken }
    console.log(payload)
    try {
        const res = await axios.post(LOGIN_API, { userData: payload })
        console.log('SILENT LOGIN RESPONSE')
        console.log(res)
        return res
    } catch (error) {
        return { success: false, error: error.message }
    }
}

export default silentLoginService
